import { Component,Input,  OnInit, EventEmitter, Output, SimpleChanges } from '@angular/core';
import { MenuItem } from '@common/models/menu-item';
import { Router } from '@angular/router';
import { NavMenuService } from '@root/modules/common/services/nav-menu.service';

@Component({
  selector: 'transact-menu',
  templateUrl: './transact-menu.component.html',
  styleUrls: ['./transact-menu.component.scss'],
})
export class TransactMenuComponent implements OnInit {

  @Input() schemeCode: string;

  @Input() isNewFundOffer:boolean;

  activeTransactTab: string;

  @Output() transactionSelected = new EventEmitter(); 

  transactMenuItems: MenuItem[] = [
    {
      displayName: 'Start a SIP ',
      url: '/transact/sip-transaction',
      activeTab: 'sip',
      icon: 'assets/images/menu-icons/web-menu/Dashboard-icon.png',
      disabled: false
    },
    {
      displayName: 'Invest Lumpsum',
      url: '/transact/invest-lumpsum',
      activeTab: 'lumpsum',
      icon: 'assets/images/menu-icons/web-menu/transact-icon.svg',
      disabled: false
    },
    {
      displayName: 'Switch',
      url: '/transact/switch-stp-transaction',
      activeTab: 'switch-stp',
      icon: 'assets/images/menu-icons/web-menu/Portfolio-icon.png',
      disabled: false
    },
    {
      displayName: 'Redeem',
      url: '/transact/redeem-swp-transaction',
      activeTab: 'redeem-swp',
      icon: 'assets/images/menu-icons/web-menu/My-goal-icon.png',
      disabled: false
    }

  ]

  constructor(private router: Router, private navMenuService:NavMenuService) { }

  setTransactActiveTab(selectedTab) {
    this.activeTransactTab=selectedTab.activeTab;
    if(this.schemeCode){
      this.router.navigate([selectedTab.url], {queryParams:{schemeCode: this.schemeCode}});
    }else{
      this.router.navigate([selectedTab.url]);
    }
    this.transactionSelected.emit();
    this.navMenuService.setIsTransactTabActive(false) //transact menu collapsed
  }

  closeMobileTransactMenu() {
    this.transactionSelected.emit();
  }

  ngOnInit() {
    this.navMenuService.getActiveTransactMenuTab().subscribe(selectedTab => {
      this.activeTransactTab = selectedTab;
    })
  }

  ngOnChanges(changes:SimpleChanges){
    if(changes['isNewFundOffer']){
      this.transactMenuItems.forEach(item => {
        if(this.isNewFundOffer){
          item.disabled = item.activeTab === 'switch-stp' || item.activeTab === 'redeem-swp'
        }
      })
    }
  }
}
